<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Payments</h1>
    <p>We’ve set up a standard list of common payment types that most companies use — such as basic pay, overtime, and bonuses. These are already included in your payroll setup by default.</p>
    <p>
      <a @click.prevent="showHelpPanel = !showHelpPanel">
        See our default payments.
      </a>
    </p>
    <div class="help-panel" style="margin-bottom: 20px;" v-if="showHelpPanel" >
      <div style="float: right;"><button type="button" style="font-size: 40px; margin-top:-20px;" @click.prevent="showHelpPanel = !showHelpPanel">&times;</button></div>
      <h4>Default Payments</h4>
      <p>
        <ul>
          <li v-for="(payment, idx) in defaultPayments" :key="idx">
            {{ payment }}
          </li>
        </ul>
      </p>
    </div>
    <p>However, if you have any additional payment types that you use, please let us know so we can add them to your payroll setup.</p>
    <p>For each additional payment type, we’ll need to understand how it should be treated for Tax, National Insurance, and Pension purposes, so we can ensure it’s processed correctly.</p>
    </div>

    <!---
    <div v-for="(payment, index) in formData.payments" :key="index" class="cell small-6">
      <PaymentCreationCard
        :payment="payment"
        :itemNumber="index + 1"
        @remove-payment="formData.payments.splice(index, 1)"
      />
    </div>
    <div class="cell small-12">
        <a href="#" @click.prevent="props.formData.payments.push({ name: '', tax: false, ni: false, pension: false })" class="btn btn-cta" style="display: inline-block; margin-top: 10px;">
          Add Additional Payment +
        </a>
    </div>
  -->

    <div class="cell small-12">
      <EditableTable
        v-model="formData.payments"
        :columns="columns"
        :buttonName="'Add Additional Payment'"
      />
    </div>

</template>


<script setup>

import { ref, onMounted } from 'vue'
import defaultPayments from '@/helpers/arrays/defaultPayments';
import EditableTable from '@/components/controls/EditableTable.vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})

const showHelpPanel = ref(false);

const columns = [
  { field: 'name', label: 'Payment Name', type: 'text', placeholder: 'Enter payment name' },
  { field: 'tax', label: 'Applicable for Tax', type: 'checkbox' },
  { field: 'ni', label: 'Applicable for NI', type: 'checkbox' },
  { field: 'pension', label: 'Included for Pension', type: 'checkbox' }
]



const validateStep = () => {

  error.value = [];

  const nameMap = new Map();
  props.formData.payments.forEach((payment, idx) => {
    if (!payment.name || !payment.name.trim()) {
      error.value.push(`Payment ${idx + 1} must have a name.`);
    }

    const name = (payment.name || '').trim().toLowerCase();
    if (name) {
      if (nameMap.has(name)) {
        error.value.push(`Payment ${name} is duplicated.`);
      } else {
        nameMap.set(name, idx);
      }
    }

  });


  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>